import { RadioButton as AlphaRadioButton } from '@oneaudi/unified-web-alpha-components';

export default AlphaRadioButton;
